"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _excluded = ["size", "thickness", "className", "verticallyCenter", "color", "variant", "value", "ref"];

var Loader = function Loader(props) {
  var size = props.size,
      thickness = props.thickness,
      className = props.className,
      verticallyCenter = props.verticallyCenter,
      color = props.color,
      variant = props.variant,
      value = props.value,
      ref = props.ref,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _styles.useStyles)(props);
  var renderedVariant = value ? "determinate" : "indeterminate";
  var loader = variant === "linear" ? /*#__PURE__*/_react.default.createElement(_LinearProgress.default, {
    className: (0, _classnames.default)("prmbl-loader-inner", classes.inner, className),
    color: color === "inherit" ? undefined : color,
    value: value,
    variant: renderedVariant,
    ref: ref
  }) : /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    className: (0, _classnames.default)("prmbl-loader-inner", classes.inner, className),
    size: size,
    thickness: thickness,
    color: color,
    value: value,
    variant: renderedVariant,
    ref: ref
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)("prmbl-loader", classes.root, (0, _defineProperty2.default)({}, classes.circular, variant === "circular"), (0, _defineProperty2.default)({}, classes.verticallyCenter, verticallyCenter))
  }, otherProps), loader);
};

exports.Loader = Loader;
Loader.defaultProps = {
  verticallyCenter: false,
  color: "primary",
  variant: "circular"
};
var _default = Loader;
exports.default = _default;